import { type FC, useCallback, useMemo } from "react";
import { cn } from "../../../utils";
import { FieldCheckbox, type FieldCheckboxPropsSingle } from "../field-checkbox";
import { type GridRowData, useGridForm } from "./use-grid-form";

export interface GridSelectAllCheckboxProps extends Partial<FieldCheckboxPropsSingle> {}

export const GridSelectAllCheckbox: FC<GridSelectAllCheckboxProps> = ({ className, inputProps, ...props }) => {
  const { data, selectedRowIds, formContext } = useGridForm();
  const { setValue } = formContext;

  const handleSelectAllChange = useCallback(
    (checked: boolean) => setValue("rowIds", checked ? data?.map((row: GridRowData) => row.id) : []),
    [data, setValue]
  );

  const checkedState = useMemo(() => {
    if (!data?.length || !selectedRowIds?.length) {
      return false;
    }

    if (data?.length === selectedRowIds?.length) {
      return true;
    }

    return "indeterminate";
  }, [data?.length, selectedRowIds?.length]);

  return (
    <FieldCheckbox
      {...props}
      name="rowIdsSelectAll"
      onChange={handleSelectAllChange}
      inputProps={{ ...inputProps, checked: checkedState, className: "text-[10px]" }}
      className={cn("flex-none", className)}
    />
  );
};
